import React from 'react'
import Icon from '../../icon'
import * as Styles from './styles'

type Props = {
  collapsed: boolean
  onToggle: Function
}

const Toggler: React.FC<any> = (props: Props) => {
  const onClick = (): void => props.onToggle(!props.collapsed)

  return (
    <Styles.Toggler className="side-menu-toggler" onClick={onClick}>
      <Icon name={props.collapsed ? 'chevron_right' : 'chevron_left'} />
    </Styles.Toggler>
  )
}

export default Toggler
